import React from "react";
import { LOYALTY_ANNIVERSARY_PATH } from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const LoyaltyAnniversary = Loadable(React.lazy(() => import("./View")));

export const LoyaltyAnniversaryRoute: IRouteItem = {
  path: LOYALTY_ANNIVERSARY_PATH,
  element: React.createElement(LoyaltyAnniversary),
  name: "Loyalty Anniversary",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
};
